import { MESSAGE_TYPE_CONTACT_CARD, MESSAGE_TYPE_SWIPE_NOTE } from 'Lib/constants/message';

import type { Message } from 'Store/entities/types';

/**
 * @function isMessageReportable determines whether the message passed should be displayed
 * in the message selector UI/UX. Per the product requirements for a message to be
 * reportable: the message must be inbound, and contain swipe note, fast chat, or standard
 * text message content.
 * @param { String } uid - Current uid
 * @param { Message } msg - Message entity
 * @param { Number } now - Current date in unix time (ms)
 * @returns { Boolean } isReportable - Message meets product criteria to be reportable
 */
const isMessageReportable = (uid: string, msg: Message) =>
  msg.from !== uid &&
  (!msg.type || msg.type === MESSAGE_TYPE_SWIPE_NOTE || msg.type === MESSAGE_TYPE_CONTACT_CARD);

export default isMessageReportable;
